module.exports = __webpack_public_path__ + "static/media/allalerts_active_assailant.5b4735d4.svg";